import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { jeNovaVerzia } from "@/lib/novaVerzia";

/** Ako často sa karta pýta na novú verziu — nasadenie trvá ~70 s. */
export const KONTROLA_MS = 5 * 60 * 1000;

/**
 * Pás „Je nová verzia Rozpočtu — Obnoviť" (KOLO 216). Sám neobnovuje —
 * rozpísané pole by zmizlo; obnoví user, keď má uložené.
 * Pýta sa raz za 5 minút a pri návrate do okna.
 */
export function PasNovaVerzia({
  kontrola = jeNovaVerzia,
  obnov = () => window.location.reload(),
}: {
  kontrola?: () => Promise<boolean>;
  obnov?: () => void;
}): JSX.Element | null {
  const [nova, setNova] = useState(false);

  useEffect(() => {
    if (nova) return undefined;
    let zrusene = false;
    const over = (): void => {
      void kontrola().then((ano) => {
        if (ano && !zrusene) setNova(true);
      });
    };
    const priNavrate = (): void => {
      if (document.visibilityState === "visible") over();
    };
    const t = window.setInterval(over, KONTROLA_MS);
    document.addEventListener("visibilitychange", priNavrate);
    window.addEventListener("focus", over);
    return () => {
      zrusene = true;
      window.clearInterval(t);
      document.removeEventListener("visibilitychange", priNavrate);
      window.removeEventListener("focus", over);
    };
  }, [kontrola, nova]);

  if (!nova) return null;
  return (
    <div
      role="status"
      className="flex shrink-0 items-center justify-center gap-3 border-b bg-amber-50 px-4 py-1.5 text-sm text-amber-900 dark:bg-amber-950 dark:text-amber-100"
    >
      <span>Je nová verzia Rozpočtu — obnov stránku, keď máš uložené.</span>
      <Button
        size="sm"
        variant="outline"
        className="h-7 gap-1.5"
        onClick={obnov}
      >
        <RefreshCw className="h-3.5 w-3.5" />
        Obnoviť
      </Button>
    </div>
  );
}
